export default {
  root: {
    flexGrow: 1,
  },
};
